const urls = {
  external: {
    privacyPolicy: 'https://www.atlassian.com/legal/privacy-policy',
    atlassianResearchGroup: 'https://www.atlassian.com/research-group',
    contactSupportLink:
      'https://support.atlassian.com/contact/#/?inquiry_category=technical_issues',
    trustLink: 'https://www.atlassian.com/trust/atlassian-intelligence',
  },
  internal: {
    optIn: (workspaceSlug: string) =>
      `/${workspaceSlug}/workspace/settings/atlassian-intelligence`,
  },
};

export default urls;
